/* Version 1.0.0 · Created/Updated 2026-10-30.
   Keep this alternative collection template during native filtering; no global theme changes. */
(() => {
  if (window.__rbnlBfPreview) return;
  window.__rbnlBfPreview = true;
  document.addEventListener('formdata', event => {
    if (event.target.id === 'facets') event.formData.set('view', 'black-friday');
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('#facet-filters a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    url.searchParams.set('view', 'black-friday');
    link.href = url.href;
  }, true);
})();
